/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData model module.
 * @module model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData} The populated <code>PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData();

            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Date');
            }
            if (data.hasOwnProperty('tag')) {
                obj['tag'] = ApiClient.convertToType(data['tag'], Object);
            }
            if (data.hasOwnProperty('tagName')) {
                obj['tagName'] = ApiClient.convertToType(data['tagName'], 'String');
            }
            if (data.hasOwnProperty('measurement')) {
                obj['measurement'] = ApiClient.convertToType(data['measurement'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], Object);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['tagName'] && !(typeof data['tagName'] === 'string' || data['tagName'] instanceof String)) {
            throw new Error("Expected the field `tagName` to be a primitive type in the JSON string but got " + data['tagName']);
        }
        // ensure the json data is a string
        if (data['measurement'] && !(typeof data['measurement'] === 'string' || data['measurement'] instanceof String)) {
            throw new Error("Expected the field `measurement` to be a primitive type in the JSON string but got " + data['measurement']);
        }

        return true;
    }


}



/**
 * @member {Date} timestamp
 */
PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.prototype['timestamp'] = undefined;

/**
 * @member {Object} tag
 */
PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.prototype['tag'] = undefined;

/**
 * @member {String} tagName
 */
PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.prototype['tagName'] = undefined;

/**
 * @member {String} measurement
 */
PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.prototype['measurement'] = undefined;

/**
 * @member {Object} value
 */
PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.prototype['value'] = undefined;






export default PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData;

